import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=d9a2e9ca&"
import script from "./Currency.vue?vue&type=script&lang=ts&"
export * from "./Currency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports